import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 52,
    seconds: 48
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <div className="flex items-center justify-center space-x-2 text-2xl md:text-4xl font-black text-rose-400 tabular-nums tracking-tight" data-id="element-1">
      <div className="bg-rose-500/15 border border-rose-500/30 px-3 py-2 rounded-lg" data-id="element-2">
        {String(timeLeft.hours).padStart(2, '0')}
        <span className="text-sm md:text-lg block text-center font-bold text-rose-300/80 uppercase mt-1" data-id="element-3">
          hs
        </span>
      </div>
      <span className="text-rose-500/50 pb-6" data-id="element-4">:</span>
      <div className="bg-rose-500/15 border border-rose-500/30 px-3 py-2 rounded-lg" data-id="element-5">
        {String(timeLeft.minutes).padStart(2, '0')}
        <span className="text-sm md:text-lg block text-center font-bold text-rose-300/80 uppercase mt-1" data-id="element-6">
          min
        </span>
      </div>
      <span className="text-rose-500/50 pb-6" data-id="element-7">:</span>
      <div className="bg-rose-500/15 border border-rose-500/30 px-3 py-2 rounded-lg" data-id="element-8">
        {String(timeLeft.seconds).padStart(2, '0')}
        <span className="text-sm md:text-lg block text-center font-bold text-rose-300/80 uppercase mt-1" data-id="element-9">
          seg
        </span>
      </div>
    </div>;
}